import { showAlert } from './ErrorMessage';

export const backgroundColor = 'black';
export const redColor = 'red';
export const whiteColor = 'white';
export const greenColor = 'green';
export const orangeColor = 'orange';
export const grayColor = 'gray';
export const lightgrayColor = '#d9d9d9';
export const redBoxColor = '#E31E24';
export const blueBoxColor = '#85BDF9';
export const gray95BoxColor = '#f2f2f2';
export const FABRICUSER = 'Fabric';
export const GARMENTUSER = 'Garment';
export const PPC = '2';
export const IMMEDIATE = '1';
export const DIVISION = 'J1';
export const RATIO100 = 1;
export const RATIO75 = 2;
export const RATIO50 = 3;
export const RATIO25 = 4;
export const AppName = "Siyaram's";

// export const getLocation = async () => {
//   try {
//     // Assuming the static latitude, longitude, and address
//     const latitude = 19.0808064; // New York City latitude
//     const longitude = 72.8334336; // New York City longitude
//     const address = "Talmaki Road, Willingdon, H/W Ward, Zone 3, Mumbai, Maharashtra, 400054, India";

//     // Set the static location data to localStorage
//     localStorage.setItem("location", JSON.stringify({ latitude, longitude, address }));

//   } catch (error) {
//     console.error('Error setting static location:', error.message);
//   }
// };

// export const checkGeolocationStatus = () => {
//   return new Promise((resolve) => {
//     // Assuming geolocation is always enabled in this scenario
//     // You can directly call getLocation since it's static
//     getLocation();
//     resolve(true);
//   });
// };

export const getLocation = async () => {
  try {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;

        // Use OpenStreetMap Nominatim for reverse geocoding
        const reverseGeocodingUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
        const response = await fetch(reverseGeocodingUrl);
        if (response.ok) {
          const data = await response.json();
          const address = data.display_name;
          localStorage.setItem('location', JSON.stringify({ latitude, longitude, address }));
        } else {
          // console.error('Failed to fetch data:', response.status);
        }
      });
    } else {
      // console.error('Geolocation is not supported by your browser.');
    }
  } catch (error) {
    // console.error('Error getting location:', error.message);
  }
};

export const checkGeolocationStatus = () => {
  return new Promise((resolve) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        () => {
          // console.log(position);
          // Geolocation is enabled
          resolve(true);
          getLocation();
        },
        () => {
          // Geolocation is disabled or user denied the request
          // console.error('Geolocation is disabled or denied'+error);
          resolve(false);
        }
      );
      // console.log(reject);
      // console.log(navigator.geolocation.getCurrentPosition);
    } else {
      // Geolocation is not supported by the browser
      // console.error('Geolocation is not supported by your browser');
      resolve(false);
    }
  });
};

export const getLocationLogin = async () => {
  if (!navigator.geolocation) {
    showAlert('Geolocation not supported by browser', 'Validation');
    return;
  }

  const geoOptions = {
    enableHighAccuracy: false,
    timeout: 10000,        // 10 sec max wait
    maximumAge: 300000,    // 5 min cache
  };

  try {
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resolve,
        reject,
        geoOptions
      );
    });

    const { latitude, longitude } = position.coords;

    // ✅ STEP 1: Always save lat/long (MOST IMPORTANT)
    localStorage.setItem(
      'location',
      JSON.stringify({ latitude, longitude, address: '' })
    );

  } catch (error) {
    console.error(error);
    // switch (error.code) {
    //   case error.PERMISSION_DENIED:
    //     showAlert('Please enable location permission', 'Validation');
    //     break;
    //   case error.POSITION_UNAVAILABLE:
    //     showAlert('Location unavailable on this network', 'Validation');
    //     break;
    //   case error.TIMEOUT:
    //     showAlert('Location request timed out. Try again.', 'Validation');
    //     break;
    //   default:
    //     showAlert('Unable to fetch location', 'Validation');
    // }
  }
};


export const getPositionsForBeat = async () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation not supported'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;

          // Reverse geocoding
          const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
          const response = await fetch(url);
          let address = '';
          if (response.ok) {
            const data = await response.json();
            address = data.display_name;
          }

          // Save to localStorage (optional)
          localStorage.setItem('location', JSON.stringify({ latitude, longitude, address }));

          resolve({ latitude, longitude, address });
        } catch (err) {
          reject(err);
        }
      },
      (error) => {
        reject(error);
      }
    );
  });
};

// Ration feature configuration
export const ratioFeature = {
  allowedUserVerticals: ['Garment'],
  allowedConfSparts: ['O2', 'O3'],
  // allowedConfSparts: ['Z1', 'Z2'],
  allowedWearTypes: ['top', 'bottom'],
  topEditableSizes: ["36", "46", "48", "50"],
  bottomEditableSizes: ["42", "44"],
}

export const SALES_ORDER_WEAR_TYPE_KEY = 'salesOrderWearType';
export const DELIVERY_FORM_DATA_KEY = 'DeliveryFormdata';
export const SCHEDULED_DATA_KEY = 'scheduledData';
export const ORDER_UPDATED_LIST_KEY = 'orderupdatedList';
export const ORDER_NUMBER_KEY = 'ordernumber';
export const MATERIAL_LIST_UPDATE_KEY = 'materialListupdate';
export const SIZEX_ORIGINAL_QTY_KEY = 'sizexOriginalQty';

const normalizeWearTypeValue = (wearType) => {
  const normalizedWearType = String(wearType ?? '').trim().toLowerCase();
  return normalizedWearType || '';
};

export const getSalesOrderWearTypeLock = () => {
  return normalizeWearTypeValue(localStorage.getItem(SALES_ORDER_WEAR_TYPE_KEY));
};

export const clearSalesOrderWearTypeLock = () => {
  localStorage.removeItem(SALES_ORDER_WEAR_TYPE_KEY);
};

export const setSalesOrderWearTypeLock = (wearType) => {
  const normalizedWearType = normalizeWearTypeValue(wearType);

  if (!normalizedWearType) {
    clearSalesOrderWearTypeLock();
    return '';
  }

  localStorage.setItem(SALES_ORDER_WEAR_TYPE_KEY, normalizedWearType);
  return normalizedWearType;
};

// Keep one wear type lock for the whole sales order so Top and Bottom do not mix.
export const validateAndSyncSalesOrderWearType = (incomingWearType) => {
  const normalizedIncomingWearType = normalizeWearTypeValue(incomingWearType);

  if (!normalizedIncomingWearType) {
    return { isValid: true, lockedWearType: getSalesOrderWearTypeLock() };
  }

  const lockedWearType = getSalesOrderWearTypeLock();

  if (lockedWearType && lockedWearType !== normalizedIncomingWearType) {
    return { isValid: false, lockedWearType, normalizedIncomingWearType };
  }

  setSalesOrderWearTypeLock(normalizedIncomingWearType);
  return { isValid: true, lockedWearType: normalizedIncomingWearType };
};

export const clearCheckoutSessionData = () => {
  localStorage.setItem(DELIVERY_FORM_DATA_KEY, null);
  localStorage.setItem(SCHEDULED_DATA_KEY, null);
};

export const clearOrderBookingDraftData = () => {
  localStorage.setItem(ORDER_UPDATED_LIST_KEY, null);
  localStorage.setItem(ORDER_NUMBER_KEY, '');
  localStorage.setItem(MATERIAL_LIST_UPDATE_KEY, null);
  localStorage.setItem(SIZEX_ORIGINAL_QTY_KEY, null);
};

const normalizeConfSpart = (value) => {
  const normalizedValue = String(value ?? '').trim().toUpperCase();

  if (!normalizedValue) {
    return '';
  }

  // Treat leading 0 and O as the same code family, e.g. 02 and O2.
  return normalizedValue.replace(/^0/, 'O');
};

export const hasAllowedConfSpart = (confSpart, allowedConfSparts = []) => {
  const allowedSet = new Set(allowedConfSparts.map(normalizeConfSpart));
  const confSpartValues = String(confSpart ?? '')
    .split(',')
    .map(normalizeConfSpart)
    .filter(Boolean);

  return confSpartValues.some((value) => allowedSet.has(value));
};

export const isSFAUser = (confvalue) => {
  return String(confvalue?.isSFA) === "1";
  // console.log(user);
  // return false;
}
